import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.admin');
import { OnInit, OnDestroy } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.admin/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class LayoutAdminComponent implements OnInit, OnDestroy {
    public isOffline: boolean = false;
    private onlineFn: any;
    private offlineFn: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/access')) return;
        if (!this.service.auth.allow.role('admin', '/access')) return;

        this.isOffline = !navigator.onLine;
        this.onlineFn = () => { this.isOffline = false; this.service.render(); };
        this.offlineFn = () => { this.isOffline = true; this.service.render(); };
        window.addEventListener('online', this.onlineFn);
        window.addEventListener('offline', this.offlineFn);
    }

    ngOnDestroy() {
        if (this.onlineFn) window.removeEventListener('online', this.onlineFn);
        if (this.offlineFn) window.removeEventListener('offline', this.offlineFn);
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', false);
    }
}

export default LayoutAdminComponent;